import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  const all = [{ label: '我拥有的', value: 1, children: result.ownerList.map(m => ({ label: m.name, value: m.id, })) },
    { label: '我协作的', value: 2, children: result.cooperationList.map(m => ({ label: m.name, value: m.id, prefix: '(协作)' })) }]
  all.unshift({ label: '已选定', value: null, children: [] })
  return all
}
export default (props) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    fetchInspirations()
  }, [])

  const fetchInspirations = async () => {
    try {
      const res = await request.sget('/zhikuan/ins/inspiration/selector', { queryType: 3, rankStatus: -2 }, 'MNInspirationSearch')
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select.Cascade
    {...props}
    placeholder="灵感集"
    data={options}
    defaultLeftValue={1}
    emptyText="暂无相关灵感集"
    inputPlaceholder="搜索灵感集"
  />
}
